<template>
    <div v-if="qualifiesForZeroCostTransfer">
        <b-alert class="mt-6" show variant="info">
            <div>This server is eligible for zero-cost data transfer to your S3 Compatible Object Storage service.</div>
            <div class="mt-6">
                <p>To enable zero-cost data transfer to your Object Storage service, you will need to review the appropriate document for the operating system on your dedicated server:</p>
                
                <h4>Linux</h4>
                <ul class="list-none pl-0">
                    <li class="font-weight-bold"><a 
                        href="https://docs.serversaustralia.com.au/create-a-static-route-in-ubuntu-1804-or-newer" 
                        target="_blank" 
                        title="Create a Static Route in Ubuntu 18.04 or Newer for Unmetered Bandwidth to the Storage Platform"
                        >Ubuntu 18.04 or newer setup instructions <i class="fal fa-external-link ml-1 text-xs"></i></a></li>
                    <li class="font-weight-bold"><a 
                        href="https://docs.serversaustralia.com.au/create-a-static-route-in-centos-7-for-unmetered-bandwidth-to-the-storage-platform" 
                        target="_blank"
                        title="Create a Static Route in CentOS 7 for Unmetered Bandwidth to the Storage Platform"
                        >CentOS 7 setup instructions <i class="fal fa-external-link ml-1 text-xs"></i></a></li>
                </ul>
                
                <h4>Windows</h4>
                <ul class="list-none pl-0 mb-0">
                    <li class="font-weight-bold"><a 
                        href="https://docs.serversaustralia.com.au/create-a-static-route-in-windows-for-unmetered-bandwidth-to-the-storage-platform" 
                        target="_blank" 
                        title="Create a Static Route in Windows for Unmetered Bandwidth to the Storage Platform"
                        >Windows setup instructions <i class="fal fa-external-link ml-1 text-xs"></i></a></li>
                </ul>
                <p class="mb-0 text-sm">Or, use the following command</p>
                <sau-code :code="details.user_instructions.windows" class="mb-3 py-2" :copyable="false" />
            </div>
        </b-alert>
    </div>
</template>
<script>

import axios from 'axios';
import SauCode from '@v2/utilities/SauCode';

export default {
    props: {
        id: {
            required: true,
        }
    },

    components: { SauCode },

    data: () => ({
        storage: null,
        details: null,
        loading: true,
    }),

    mounted() {
        this.loading = true;

        const dediPromise = axios.get(`/api/v2/services/${this.id}/object-storage`)
            .then(({ data }) => {
                this.details = data;
            });

        const storagePromise = axios.get('/api/v2/storage')
            .then(({ data }) => {
                this.storage = data;
            });

        Promise.all([dediPromise, storagePromise]).then(() => {
            this.loading = false;
        });
    },

    computed: {
        hasObjectStorage() {
            if(this.loading) return false;
            return this.storage.object && 
                this.storage.object.length > 0 && 
                this.storage.object.find((os) => os.status === 'Active');
        },
        qualifiesForZeroCostTransfer() {
            return ! this.loading && 
                this.hasObjectStorage &&
                this.details.zero_cost_transfer;
        }
    }
}
</script>